import { type Translate } from 'next-translate';
import React from 'react';
import { type DropzoneOptions } from 'react-dropzone';
import { HeroImageGen } from '@/components/landing/landingTemplate/HeroImageGen';
import { HeroTextToVideo } from '@/components/landing/landingTemplate/HeroTextToVideo';
import { type HeroUnion } from '@/types';
import { HeroDefault } from '../HeroDefault';
import { HeroNoDropzone } from '../HeroNoDropzone';
import { HeroSpeechToText } from '../HeroSpeechToText';
import { HeroVideo } from '../HeroVideo';
import { HeroVideoUpload } from '../HeroVideoUpload';
import { HeroWebLink } from '../HeroWebLink';

interface Props {
	data: HeroUnion;
	t: Translate;
	dropzoneOptions: DropzoneOptions;
	isLoading: boolean;
	// TODO: Need to add funnelLinkService field to the data
	funnelLinkService?: string;
	converterCompressor?: boolean;
	referenceImagePreview?: string | null;
	referenceImageUrl?: string | null;
	onRemoveReferenceImage?: () => void;
}

export const Hero: React.FC<Props> = ({
	data,
	t,
	dropzoneOptions,
	isLoading,
	funnelLinkService,
	converterCompressor,
	referenceImagePreview,
	referenceImageUrl,
	onRemoveReferenceImage,
}) => {
	if (data.type === 'noDropzone') {
		return (
			<HeroNoDropzone data={data} t={t} funnelLinkService={funnelLinkService} />
		);
	}
	if (data.type === 'webLink') {
		return (
			<HeroWebLink data={data} t={t} funnelLinkService={funnelLinkService} />
		);
	}

	if (data.type === 'withVideo') {
		return (
			<HeroVideo data={data} t={t} funnelLinkService={funnelLinkService} />
		);
	}

	if (data.type === 'withVideoUpload') {
		return (
			<HeroVideoUpload
				data={data}
				t={t}
				isLoading={isLoading}
				dropzoneOptions={dropzoneOptions}
			/>
		);
	}

	if (data.type === 'imageGenerator') {
		return (
			<HeroImageGen
				data={data}
				t={t}
				isLoading={isLoading}
				dropzoneOptions={dropzoneOptions}
				funnelLinkService={funnelLinkService}
				referenceImagePreview={referenceImagePreview}
				referenceImageUrl={referenceImageUrl}
				onRemoveReferenceImage={onRemoveReferenceImage}
			/>
		);
	}

	if (data.type === 'speechToText') {
		return (
			<HeroSpeechToText
				data={data}
				t={t}
				isLoading={isLoading}
				dropzoneOptions={dropzoneOptions}
				funnelLinkService={funnelLinkService}
			/>
		);
	}

	if (data.type === 'textToVideo') {
		return (
			<HeroTextToVideo
				data={data}
				t={t}
				isLoading={isLoading}
				funnelLinkService={funnelLinkService}
			/>
		);
	}

	return (
		<HeroDefault
			data={data}
			t={t}
			isLoading={isLoading}
			dropzoneOptions={dropzoneOptions}
			converterCompressor={converterCompressor}
		/>
	);
};
